/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Tools_Splits_DescInputs */

const en_ui_studio_tools_splits_desc = /** @type {(inputs: Ui_Studio_Tools_Splits_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cut the route into segments you can export one at a time.`)
};

const de_ui_studio_tools_splits_desc = /** @type {(inputs: Ui_Studio_Tools_Splits_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile die Route in Abschnitte, die du einzeln exportierst.`)
};

/**
* | output |
* | --- |
* | "Cut the route into segments you can export one at a time." |
*
* @param {Ui_Studio_Tools_Splits_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_tools_splits_desc = /** @type {((inputs?: Ui_Studio_Tools_Splits_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Tools_Splits_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_tools_splits_desc(inputs)
	return de_ui_studio_tools_splits_desc(inputs)
});